import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import { useBack } from '../hooks/useBack';
import Text from '../components/atoms/Text';
import TutorialCard from '../components/molecules/TutorialCard';
import { useNavigate } from 'react-router-dom';

const Wrapper = styled.div`
  padding: 20px;
  text-align: left;
`
const GuideMessage = styled.div`
  display: flex;
  flex-direction: column;
  word-break: keep-all;
`
const Section = styled.div`
  margin: 28px 0 24px 0;  
`
const Category = styled(Text)`
  display: inline-block;
  margin-bottom: 12px;
`
const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const TutorialList = () => {
  const guideSections = [
    {
      category: "시작하기",
      menus: [
        { title: "메인 페이지", path: "main", description: "서비스의 주요 기능과 전체적인 흐름을 이해해요." },
        { title: "아이 음성 등록", path: "child-voice-register", description: "정확한 분석을 위해 아이의 목소리를 등록해요." },
      ],
    },
    {
      category: "기록하기",
      menus: [
        { path: "word-record", title: "아는 단어 기록", description: "아이만의 단어 및 표현을 기록해요." },
        { path: "word-card-record", title: "단어 카드 기록", description: "낱말 카드를 읽는 아이의 발음을 기록해요." },
        { path: "conversation-record", title: "대화 기록", description: "일상에서의 대화를 녹음해 아이의 말 사용을 기록해요." },
      ],
    },
    {
      category: "분석 및 관리",
      menus: [
        { path: "word-dictionary", title: "소통사전", description: "기록된 단어들을 모아 우리 아이만의 단어장을 만들어요." },
        { path: "conversation-note", title: "대화노트", description: "저장된 대화 스크립트를 보며 아이의 언어 표현을 확인해요" },
        { path: "report", title: "분석리포트", description: "아이와 나눈 소통의 시간과 단어 사용 특성을 확인해요." },
      ],
    },
  ];

  const goBack = useBack(); // 뒤로가기 훅 호출
  const navigate = useNavigate();

  return (
    <DefaultLayout
       headerType="sub" 
       onBack={goBack}
       title="사용 가이드"
       bgColor="gray">
      <Wrapper>
        <GuideMessage>
          <Text color="alternative">서비스 이용 방법이 궁금하신가요?</Text>
          <Text color="alternative"> 각 기능별 가이드를 통해 서비스 사용법을 확인해보세요.</Text>
        </GuideMessage>
        
        {guideSections.map((section) => (
          <Section key={section.category}>
            <Category variant="body2" weight="medium" color="accent">
              {section.category}
            </Category>
            <CardList>
               {section.menus.map((item) => (
                <TutorialCard
                  key={item.title}
                  title={item.title}
                  description={item.description}
                  onClick={() => navigate(`/mypage/tutorials/${item.path}`)}
                />
                ))}
            </CardList>
           
          </Section>
        ))}
      </Wrapper>
    </DefaultLayout>
  )
}

export default TutorialList